<template>
        <div class="max-w-5xl mx-auto">
            <div class="md:px-4">
                <div class="flex flex-wrap items-center justify-between">
                    <div class="mr-4">
                        <h2 class="mb-2 text-4xl font-bold">
                            {{ profile && profile.name }}
                        </h2>

                        <div class="flex flex-wrap items-center">
                            <h3 class="mr-8 text-xl md:mr-12">{{
                                user.active_roles && user.active_roles.length > 0
                                && user.active_roles.filter(x => UserRole.ADMIN !== x.id)
                                .map(x => x.display_name)
                                .join(', ')
                              }}
                            </h3>
                            <h3 class="flex items-center text-xl font-semibold">
                                <span class="mr-3 text-2xl text-blue-500 pi pi-star"></span>
                                <span>{{ rating }}</span>
                            </h3>
                        </div>
                    </div>

                    <!-- IF HAS USER PHOTO: -->
                    <div
                        v-if="false"
                        :style="'background: url(https://joeschmoe.io/api/v1/3) no-repeat center center; background-size: cover;'"
                        class="w-24 h-24 mt-4 bg-gray-300 rounded-full md:w-32 md:h-32"
                    ></div>
                    <!-- ELSE: -->
                    <div
                        v-else
                        class="flex items-center justify-center w-24 h-24 mt-4 bg-blue-500 rounded-full md:w-32 md:h-32"
                    >
                        <div class="text-white text-5xl font-semibold">
                            {{ profile && profile.name && profile.name.split(' ').map((n) => n[0]).join('') }}
                        </div>
                    </div>
                </div>

                <tab-view @tab-change="changeTab" ref="profileTabView">
                    <tab-panel>
                        <template slot="header">
                            <h3 class="text-lg">Andmed</h3>
                        </template>

                        <div class="flex flex-wrap py-6 -mx-4">
                            <div class="w-full px-4 md:w-1/2 py-3">
                                <h3 class="text-xl font-semibold text-black">Kontaktandmed</h3>

                                <div class="my-6">
                                    <h4 class="mb-1 text-sm text-blue-500 uppercase">E-mail</h4>
                                    <input-text
                                        v-if="isCurrentUser"
                                        id="emailInput"
                                        placeholder=" "
                                        v-model="user.email"
                                        class="w-full"
                                        :disabled="!isCurrentUser"
                                        @change="updateEmail"
                                    />
                                    <p v-else class="text-lg">{{ user.email }}</p>
                                </div>

                                <div v-if="isCurrentUser" class="my-3 inline-flex">
                                  <checkbox
                                      name="emailEnabled"
                                      class="mr-2"
                                      binary
                                      v-model="user.emailEnabled"
                                      @change="changeEmailEnabled"
                                  />
                                  <h4 class="mb-1 text-sm text-blue-500 uppercase">Soovin saada emaile</h4>
                                </div>

                                <div v-if="isCurrentUser" class="my-3 inline-flex">
                                  <checkbox
                                      name="profileHidden"
                                      class="mr-2"
                                      binary
                                      v-model="user.profileHidden"
                                      @change="changeProfileHidden"
                                  />
                                  <h4 class="mb-1 text-sm text-blue-500 uppercase">Ära kuva minu nime anonüümsetele tellijatele</h4>
                                </div>

                                <div v-if="user && isCurrentUser" class="my-6">
                                  <h4 class="mb-1 text-sm text-blue-500 uppercase">Telefon</h4>
                                  <div class="flex justify-between">
                                    <input-mask
                                        id="phone-code"
                                        v-model="user.phoneCode"
                                        placeholder="+372"
                                        mask="+***"
                                        prefix="+"
                                        class="w-10"
                                        :disabled="!isCurrentUser"
                                        @change="updatePhoneCode"/>
                                    <input-text
                                        id="phoneInput"
                                        placeholder=" "
                                        v-model="user.phone"
                                        class="w-full"
                                        :use-grouping="false"
                                        :disabled="!isCurrentUser"
                                        @change="updatePhone"/>
                                  </div>
                                </div>
                                <div v-else-if="user && !isCurrentUser && user.phone" class="my-6">
                                  <h4 class="mb-1 text-sm text-blue-500 uppercase">Telefon</h4>
                                  <p class="text-lg">+{{ user.phoneCode }} {{ user.phone }}</p>
                                </div>

                                <div v-if="false" class="my-6">
                                    <h4 class="mb-1 text-sm text-blue-500 uppercase">Kirjeldus</h4>
                                    <p class="text-lg">Projekteerija kogemus 20 aastat</p>
                                </div>
                            </div>

                            <div class="w-full px-4 md:w-1/2 py-3">
                                <h3 class="text-xl font-semibold text-black">Pädevus</h3>

                                <div v-if="false" class="my-6">
                                    <h4 class="mb-1 text-sm text-blue-500 uppercase">Kool</h4>
                                    <p class="text-lg">TalTech</p>
                                </div>

                                <div class="my-6">
                                    <h4 class="mb-1 text-sm text-blue-500 uppercase">Kutsestandardid
                                      <span
                                          v-tooltip.top="
                                            '<div class=\x22flex text-lg\x22>' +
                                            '<i class=\x22text-xl text-blue-500 pr-1 pi pi-verified\x22></i>' +
                                            'Tähistab Iffenti poolt määratud kutset neile, kellel Kutsekoja järgi valdkonnapõhist kutsetaset ei ole, küll aga on vastav haridus.' +
                                            '</div>'"
                                          class="pi pi-info-circle text-gray-600"
                                          escape="false"
                                      ></span>
                                    </h4>

                                    <template v-for="qualification in qualifications">
                                        <div :key="qualification.id" class="text-lg mb-1">
                                            <a v-if="qualification.qualification_issuer.id !== QualificationIssuer.IFFENT" :href="'https://www.kutseregister.ee/ctrl/et/Tunnistused/vaata/' + qualification.qf_id + '/1'"
                                               target="_blank" rel="noopener noreferrer">{{
                                                    qualification.level.name
                                                }}</a>

                                            <div
                                                :key="qualification.id"
                                                v-if="qualification.qualification_issuer.id === QualificationIssuer.IFFENT"
                                                class="flex text-lg">
                                                <span>
                                                  {{ qualification.level.name }}
                                                </span>
                                                <i class="text-xl text-blue-500 pl-1 pi pi-verified"></i>
                                            </div>
                                        </div>
                                    </template>
                                </div>

                                <div class="my-6" v-if="isCurrentUser && UserRole.contains(UserRole.DRAFTSMAN, user.active_roles)" >
                                  <h4 class="mb-1 text-sm text-blue-500 uppercase">Lisateenused
                                    <span
                                        v-tooltip.top="
                                              '<div class=\x22flex text-lg\x22>' +
                                              '<i class=\x22text-xl text-blue-500 pr-1 pi pi-verified\x22></i>' +
                                              'Vali lisateenused mille kohta soovid projektis osalemise kutseid saada' +
                                              '</div>'"
                                        class="pi pi-info-circle text-gray-600"
                                        escape="false"
                                    ></span>
                                  </h4>
                                  <MultiSelect v-model="selectedSecondaryAreas"
                                               :options="secondaryAreas"
                                               optionLabel="secondaryArea"
                                               placeholder="Vali lisateenused"
                                               @change="secondaryAreasChanged"
                                               @hide="updateSecondaryAreas">
                                    <template #value="slotProps">
                                      <div v-for="option of slotProps.value" :key="option.name">
                                        <span>{{option.name}}</span>
                                      </div>
                                      <template v-if="!slotProps.value || slotProps.value.length === 0">
                                        Vali lisateenused
                                      </template>
                                    </template>
                                    <template #option="slotProps">
                                      <div>
                                        <span>{{slotProps.option.name}}</span>
                                      </div>
                                    </template>
                                  </MultiSelect>
                                </div>

                                <div v-if="isCurrentUser">
                                  <div class="my-6" v-if="isCurrentUser && (UserRole.contains(UserRole.DRAFTSMAN, user.active_roles) || UserRole.contains(UserRole.PROJECT_MANAGER, user.active_roles))">
                                    <h4 class="mb-1 text-sm text-blue-500 uppercase">Tarkvara</h4>
                                    <MultiSelect v-model="selectedSoftwares"
                                                 :options="softwares"
                                                 optionLabel="software"
                                                 placeholder="Vali tarkvara"
                                                 @change="softwareChanged"
                                                 @hide="updateSoftware">
                                      <template #value="slotProps">
                                        <div v-for="option of slotProps.value" :key="option.name">
                                          <span>{{option.name}}</span>
                                        </div>
                                        <template v-if="!slotProps.value || slotProps.value.length === 0">
                                          Vali tarkvarad
                                        </template>
                                      </template>
                                      <template #option="slotProps">
                                        <div>
                                          <span>{{slotProps.option.name}}</span>
                                        </div>
                                      </template>
                                    </MultiSelect>
                                  </div>
                                </div>
                                <div v-else>
                                  <div class="my-6" v-if="selectedSoftwares.length > 0">
                                    <h4 class="mb-1 text-sm text-blue-500 uppercase">Tarkvara</h4>
                                    <template v-for="software in selectedSoftwares">
                                      <div :key="software.id" class="text-lg mb-1">
                                        {{ software.name }}
                                      </div>
                                    </template>
                                  </div>
                                </div>
                            </div>

                            <div v-if="isCurrentUser" class="w-full px-4 md:w-1/2 py-3">
                              <h3 class="text-xl font-semibold text-black py-3">Parool</h3>
                              <router-link
                                  to="/profile/password"
                                  class="bg-blue-300 btn btn-sm uppercase text-xs">
                                <span v-if="user.hasPassword">Muuda</span>
                                <span v-else>Lisa</span>
                              </router-link>
                            </div>
                        </div>
                    </tab-panel>

                    <tab-panel v-if="projects && projects.length">
                        <template slot="header">
                            <h3 class="text-lg">Tehtud tööd</h3>
                        </template>

                        <div class="py-6">
                            <div
                                v-for="(project) in projects"
                                :key="project.id"
                                class="bg-white py-4 mb-3 rounded-lg shadow-lg"
                            >
                                <div class="flex flex-wrap items-center justify-between">
                                    <div class="flex items-center px-6">
                                        <div class="flex items-center">
                                            <div class="flex-1 font-semibold">{{ project.name }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="false" class="py-6">
                            <div
                                v-for="work in profile.works"
                                :key="work.title"
                                class="flex flex-wrap justify-between mb-6 -mx-4"
                            >
                                <div class="w-full px-4 md:w-1/2">
                                    <div class="my-6">
                                        <h4 class="mb-1 text-sm text-blue-500 uppercase">{{ work.date }}</h4>
                                        <h3 class="mb-3 text-xl font-semibold text-black">{{ work.title }}</h3>
                                        <p class="text-lg">{{ work.description }}</p>
                                    </div>
                                </div>

                                <div class="px-4 md:max-w-sm">
                                    <galleria :value="work.gallery" :num-visible="4">
                                        <template #item="slotProps">
                                            <img :src="slotProps.item.itemImageSrc" />
                                        </template>
                                        <template #thumbnail="slotProps">
                                            <img :src="slotProps.item.thumbnailImageSrc" class="mx-2" />
                                        </template>
                                    </galleria>
                                </div>
                            </div>
                        </div>
                    </tab-panel>

                    <tab-panel>
                        <template slot="header">
                            <h3 class="text-lg">Minu ettevõtted</h3>
                        </template>

                        <div v-if="isCurrentUser" class="py-6">
                            <div
                                v-for="(business, i) in businesses" :key="business.businessUserId"
                                class="bg-white py-4 mb-3 rounded-lg shadow-lg">
                                <div class="flex flex-wrap items-center justify-between">
                                    <div class="flex items-center px-6">
                                        <div class="flex items-center">
                                            <div class="flex items-center mr-4">
                                                <radio-button
                                                    :inputId="business.businessUserId"
                                                    name="name"
                                                    :value="business"
                                                    @change="businessChange(business)"
                                                    v-model="selectedBusiness"
                                                />
                                            </div>
                                            <div class="flex-1 font-semibold">{{ business.name }}</div>
                                        </div>
                                    </div>

                                    <div class="w-full md:w-2/5 flex justify-end px-6">
                                      <button
                                          class="btn btn-sm uppercase text-blue text-xs mx-4"
                                          @click="businessesExpandedRows.splice(i,1, businessesExpandedRows[i] = !businessesExpandedRows[i])">
                                        Muuda andmeid
                                      </button>

                                      <button
                                          v-if="business.businessUserId"
                                          class="btn btn-sm uppercase text-xs text-white bg-orange-400"
                                          @click="removeBusiness(business.businessUserId, i)">
                                        Kustuta
                                      </button>
                                    </div>
                                </div>

                                <transition name="accordion" mode="out-in">
                                    <div
                                        v-if="businessesExpandedRows[i]"
                                        :key="'expanded_' + i + '_' + businessesExpandedRows[i]"
                                    >
                                        <div class="border-t-2 my-4"></div>
                                        <div class="flex flex-wrap items-center">
                                            <div class="w-full sm:w-3/5 my-2 px-6">
                                                <div v-if="business.code" class="w-full">
                                                  <span class="font-semibold">Registrikood:</span> {{ business.code}}
                                                </div>
                                                <div v-if="business.businessUserId" class="w-full">
                                                  <span class="font-semibold">Aadress:</span> {{ business.address}}
                                                </div>
                                                <div v-else class="w-full">
                                                  <input-text
                                                      placeholder="Lisa aadress"
                                                      v-model="business.address"
                                                      class="w-full"
                                                  />
                                                </div>
                                                <input-text
                                                    placeholder="Lisa konto number"
                                                    v-model="business.accountNumber"
                                                    class="w-full"
                                                />
                                            </div>

                                            <div class="w-full sm:w-2/5 text-right my-2 px-6">
                                                <button
                                                    class="bg-blue-300 btn btn-sm uppercase text-xs"
                                                    @click="updateBusinessInfo(business, i)"
                                                >Salvesta
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </transition>
                            </div>

                            <div
                                :class="newBusinessExpanded ? 'bg-white shadow-lg' : ''"
                                class=" py-4 px-6 rounded-lg transition duration-300"
                            >
                                <button class="flex items-center" @click="newBusinessExpanded = !newBusinessExpanded">
                                    <div
                                        class="flex items-center justify-center w-6 h-6 text-white bg-blue-500 rounded-full mr-4 shadow-md">
                                        <span class="pi pi-plus font-semibold"></span>
                                    </div>
                                    <div class="font-semibold">Lisa uus</div>
                                </button>

                                <transition name="accordion" mode="out-in">
                                    <div v-if="newBusinessExpanded" key="newBusinessExpanded">
                                        <div class="py-4">
                                            <div class="flex flex-wrap items-center">
                                                <div class="w-full md:w-3/5 py-4">
                                                        <auto-complete
                                                            id="newBusiness"
                                                            placeholder="Ettevõte"
                                                            v-model="newBusiness"
                                                            field="name"
                                                            :suggestions="newBusinessOptions"
                                                            class="w-full"
                                                            @complete="businessSearch($event)"
                                                            :delay="2000"
                                                            :forceSelection="true">
                                                          <template #item="slotProps">
                                                            <div>{{ slotProps.item.name }} <span v-if="slotProps.item.status && BusinessStatus.DELETED === slotProps.item.status.id" class="text-red-600 pi pi-exclamation-circle"></span></div>
                                                          </template>
                                                        </auto-complete>
                                                        <input-text
                                                            placeholder="Lisa konto number"
                                                            v-model="newBusinessAccountNumber"
                                                            class="w-full"
                                                        />
                                                </div>

                                                <div class="w-full sm:w-2/5 text-right my-2 px-6">
                                                    <button
                                                        class="btn btn-sm uppercase text-xs mx-4"
                                                        @click="clearNewBusiness"
                                                    >Kustuta
                                                    </button>

                                                    <button
                                                        :disabled="newBusiness === null"
                                                        class="btn btn-sm uppercase text-xs bg-blue-200"
                                                        @click="saveNewBusiness"
                                                    >Lisa
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </transition>
                            </div>
                        </div>

                        <div v-else class="py-6">
                          <div v-for="(business) in businesses" :key="business.businessUserId"
                               class="bg-white py-4 mb-3 rounded-lg shadow-lg">
                            <div class="flex flex-wrap items-center justify-between">
                              <div class="flex items-center px-6">
                                <div class="flex items-center">
                                  <div class="flex-1 font-semibold">{{ business.name }}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                    </tab-panel>


                    <tab-panel v-if="isCurrentUser && roles && roles.length > 0">
                        <template slot="header">
                            <h3 class="text-lg">Aktiivne roll</h3>
                        </template>

                        <div class="py-6">
                            <div
                                v-for="(role, i) in roles"
                                class="bg-white py-4 mb-3 rounded-lg shadow-lg"
                                :key="i"
                            >
                                <div class="flex flex-wrap items-center justify-between">
                                    <div class="flex items-center px-6">
                                        <div class="flex items-center">
                                            <div class="flex items-center mr-4">
                                                <checkbox
                                                    :inputId="'role' + i"
                                                    name="role"
                                                    :value="role"
                                                    v-model="user.active_roles"
                                                    @change="changeRole"
                                                />
                                            </div>
                                            <div class="flex-1 font-semibold">{{ role.display_name }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </tab-panel>

                  <tab-panel key="ratings">
                    <template slot="header">
                      <h3 class="text-lg">Hinnangud</h3>
                    </template>
                    <div class="py-6">

                      <div v-for="(projectRating, i) in projectRatings" :key="i">
                          <div v-for="(userRating, j) in projectRating.userRatings" :key="j">
                            <div class="font-bold">{{projectRating.projectName}}</div>
                            <div>{{userRating.giverName}} - {{userRating.commentDate}}</div>
                            <div style="font-style: italic;" >“{{userRating.comment}}”</div>
                            <div>_________________________________________________________________</div>
                          </div>
                      </div>
                    </div>
                  </tab-panel>

                </tab-view>
            </div>

            <div v-if="changed" class="flex flex-col items-center mt-10">
                <button class="w-full text-white bg-blue-500 uppercase btn xs:w-72" @click="confirmRole">
                    Kinnita andmed
                </button>
            </div>
        </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { cloneDeep } from 'lodash';
import store from "../store";
import {QualificationIssuer} from "../utils/qualification.issuer";
import {UserRole} from "../utils/user.role";
import {
  newBusiness, updateBusiness, setDefaultBusiness, removeBusiness, getRatings, changeRoles,
  getProfile, toggleEmailEnabled, toggleProfileHidden, updateEmail, updatePhoneCode, updatePhone,
  getSoftware, updateSoftware, updateSecondaryAreas, getQualifications
} from "@/store/user.api";
import {findBusiness} from "@/store/business.api";
import {BusinessStatus} from "../utils/business.status";
import {getAreasByType} from "@/store/area.api";
import {AreaType} from "@/utils/area.type";

export default {
    components: {
    },
    props: ['memberId'],
    watch: {
        currentUser(val) {
            this.user = cloneDeep(val);
        },
    },
    data() {
        return {
            timer: undefined,
            businesses: [
                {
                    id: 0,
                    name: 'Merko Ehitus AS'
                },
                {
                    id: 1,
                    name: 'Sirke & Mall OÜ'
                },
                {
                    id: 2,
                    name: 'Standup Studio OÜ'
                }
            ],
            selectedBusiness: null,
            businessesExpandedRows: [],
            newBusinessExpanded: false,
            newBusiness: null,
            newBusinessAccountNumber: null,
            newBusinessOptions: [],
            changed: false,

            projects: [],
            qualifications: [],
            rating: null,
            roles: [],
            user: {},
            projectRatings: [],
            payments: [
                {
                  id: 1,
                  name: "Isiklikule pangakontole"
                },
                {
                  id: 2,
                  name: "Arvega"
                },
                {
                  id: 3,
                  name: "Tööandjalt palgana"
                },
            ],
            selectedPayment: null,
            selectedSoftwares: [],
            softwares: [],
            selectedSecondaryAreas: [],
            secondaryAreas: [],
            hasSoftwareChanged: false,
            hasSecondaryAreasChanged: false
        }
    },
    computed: {
      UserRole() {
        return UserRole
      },
      BusinessStatus() {
        return BusinessStatus
      },
      QualificationIssuer() {
        return QualificationIssuer
      },
      AreaType() {
        return AreaType
      },
        ...mapGetters({
            currentUser: 'global/user',
            isAdmin: 'global/isAdmin',
        }),
        isCurrentUser() {
            return this.user.id === this.memberId
                || this.user.id === this.$route?.params?.id
                || this.memberId === undefined && !this.$route?.params?.id;
        },
        profile() {
            return {
                name: this.user?.name,
                xp: '15',
                disabled: false,
                works: [
                    {
                        date: '2018 - 2019',
                        title: 'Valgamaa Kutseõppekeskus',
                        description:
                            'Valgamaa Kutseõppekeskuse projekti vedamine ja siia võib veel pikeamlt kirjeldada, mis olid täpsemad kohustused selles projektis',
                        gallery: [
                            {
                                itemImageSrc: 'https://picsum.photos/seed/1/800/800',
                                thumbnailImageSrc: 'https://picsum.photos/seed/1/800/800'
                            },
                            {
                                itemImageSrc: 'https://picsum.photos/seed/2/800/800',
                                thumbnailImageSrc: 'https://picsum.photos/seed/2/800/800'
                            },
                            {
                                itemImageSrc: 'https://picsum.photos/seed/3/800/800',
                                thumbnailImageSrc: 'https://picsum.photos/seed/3/800/800'
                            },
                            {
                                itemImageSrc: 'https://picsum.photos/seed/4/800/800',
                                thumbnailImageSrc: 'https://picsum.photos/seed/4/800/800'
                            },
                            {
                                itemImageSrc: 'https://picsum.photos/seed/5/800/800',
                                thumbnailImageSrc: 'https://picsum.photos/seed/5/800/800'
                            }
                        ]
                    }
                ]
            };
        },
    },
    methods: {
        goBack() {
            this.$router.go(-1);
        },
        changeRole() {
            this.changed = true
        },
        changeEmailEnabled() {
          toggleEmailEnabled().then(() => {
            this.showToast('Emailide saamine muudetud', 'success')
          }, (error) => {
            const toast = error.response?.data;
            if (toast) {
              this.processAxiosPositiveResponse(toast);
            } else {
              this.showToast('Emailide saamise muutmine ebaõnnestus', 'error');
            }
          })
        },
        changeProfileHidden() {
          toggleProfileHidden().then(() => {
            this.showToast('Profiili kuvamine muudetud', 'success')
          }, (error) => {
            const toast = error.response?.data;
            if (toast) {
              this.processAxiosPositiveResponse(toast);
            } else {
              this.showToast('Profiili kuvamise muutmine ebaõnnestus', 'error');
            }
          })
        },
        async businessSearch(event) {
          if (!event.query) {
            return;
          }

          if (event.query.length < 3) {
            this.showToast('Ettevõtte nimi peab olema pikem kui 2 tähemärki', 'warn')
            return;
          }

          const { data } = await findBusiness(event.query);
          if (data) {
            this.newBusinessOptions = data;
          }
        },
        updateBusinessInfo(business, i) {
            if (business.businessUserId === null) {
              if ((!business.address || business.address === '') || (!business.accountNumber || business.accountNumber === '')) {
                this.showToast('Palun sisesta eraisiku aadress ja konto number', 'warn');
                return;
              }
            } else {
              if (!business.accountNumber || business.accountNumber === '') {
                this.showToast('Palun sisesta ettevõtte konto number', 'warn');
                return;
              }
            }

            updateBusiness(business).then((resp) => {
              this.processAxiosPositiveResponse(resp.data);
              this.businessesExpandedRows.splice(i, 1, false)
            }, (error) => {
              const toast = error.response?.data;
              if (toast) {
                this.processAxiosPositiveResponse(toast);
              } else {
                this.showToast('Ettevõtte info muutmine ebaõnnestus', 'error');
              }
            });
        },
        saveNewBusiness() {
            if (this.newBusiness !== null) {
                if (!this.newBusiness.name || this.newBusiness.name === '') {
                  this.showToast('Palun sisesta uue ettevõtte nimi', 'warn')
                  return;
                }

                this.newBusiness.accountNumber = this.newBusinessAccountNumber;

                newBusiness(this.newBusiness).then((resp) => {
                  this.clearNewBusiness();
                  this.businesses.splice(this.businesses.length-1, 0, {
                    businessUserId: resp.data.businessUserId,
                    name: resp.data.name,
                    code: resp.data.code,
                    accountNumber: resp.data.accountNumber,
                    address: resp.data.address
                  });

                  this.selectedBusiness = this.businesses.find(key => {
                    return key.businessUserId === resp.data.businessUserId;
                  });

                  this.$store.dispatch('global/getUser');
                  this.showToast('Lisatud');
                }, (error) => {
                  const toast = error.response?.data;
                  if (toast) {
                    this.processAxiosPositiveResponse(toast);
                  } else {
                    this.$toast.add({
                      severity: 'error',
                      summary: "Ettevõtte lisamine ebaõnnestus",
                      life: 3000,
                      closable: false
                    })
                  }
                });
            }
        },
        clearNewBusiness() {
            this.newBusinessExpanded = false
            this.newBusiness = null
        },
        businessChange(b) {
          const payload = {
            businessUserId: b.businessUserId,
            name: b.name
          };
          setDefaultBusiness(payload).then((resp) => {
            this.processAxiosPositiveResponse(resp.data);
            this.$store.dispatch('global/getUser');
          });
        },
        removeBusiness(businessId, index) {
          removeBusiness(businessId).then((resp) => {
            if (this.businesses[index] === this.selectedBusiness) {
              this.selectedBusiness = this.businesses.find(key => {
                return key.businessUserId === null;
              });
            }
            this.businesses.splice(index, 1);

            this.processAxiosPositiveResponse(resp.data);
            this.$store.dispatch('global/getUser');
          });
        },
        confirmRole() {
            changeRoles(this.user.active_roles).then(({data}) => {
                this.processAxiosPositiveResponse(data);
                if(data?.user) {
                    this.$store.commit('global/setUser', data.user);
                }
                this.changed = false;
            });
        },

      updateEmail() {
        updateEmail(this.user.email).then(({ data })=> {
          store.dispatch('global/getUser');
          this.processAxiosPositiveResponse(data);
        },(error) => {
          const toast = error.response?.data;
          if (toast) {
            this.processAxiosPositiveResponse(toast);
          }
        });
      },
      updatePhoneCode() {
        if (this.user.phoneCode === undefined || this.user.phoneCode === '') {
          this.user.phoneCode = "372";
        }

        if (this.user.phoneCode.startsWith('+')) {
          this.user.phoneCode = this.user.phoneCode.substring(1);
        }

        updatePhoneCode(this.user.phoneCode).then(({ data })=> {
          store.dispatch('global/getUser');
          this.processAxiosPositiveResponse(data);
        },(error) => {
          const toast = error.response?.data;
          if (toast) {
            this.processAxiosPositiveResponse(toast);
          }
        });
      },
      updatePhone() {
        updatePhone(this.user.phone).then(({ data })=> {
          store.dispatch('global/getUser');
          this.processAxiosPositiveResponse(data);
        },(error) => {
          const toast = error.response?.data;
          if (toast) {
            this.processAxiosPositiveResponse(toast);
          }
        });
      },

      async changeTab(e) {
        if (this.$refs.profileTabView.$children[e.index].$vnode.key === 'ratings') {
          const {data} = await getRatings();
          this.projectRatings = data;
        }
      },
      softwareChanged() {
          this.hasSoftwareChanged = true;
      },
      updateSoftware() {
          if (this.hasSoftwareChanged) {
              updateSoftware(this.selectedSoftwares).then(({data}) => {
                  this.processAxiosPositiveResponse(data);
                  this.hasSoftwareChanged = false;
              },(error) => {
                  const toast = error.response?.data;
                  if (toast) {
                      this.processAxiosPositiveResponse(toast);
                  }
              });
          }
      },
      secondaryAreasChanged() {
          this.hasSecondaryAreasChanged = true;
      },
      updateSecondaryAreas() {
        if (this.hasSecondaryAreasChanged) {
          updateSecondaryAreas(this.selectedSecondaryAreas).then(({data}) => {
            this.processAxiosPositiveResponse(data);
            this.hasSecondaryAreasChanged = false;
            this.getQualifications();
          },(error) => {
            const toast = error.response?.data;
            if (toast) {
              this.processAxiosPositiveResponse(toast);
            }
          });
        }
      },
      async getQualifications() {
        getQualifications().then(result => {
          this.qualifications = result.data;
        });
      },
    },
    async mounted() {
      let data;
      if (this.memberId) {
          data = (await getProfile(this.memberId))?.data;
          this.user = data?.user;
      } else if (this.$route?.params?.id) {
          data = (await getProfile(this.$route.params.id))?.data;
          this.user = data?.user;
      } else {
          data = (await getProfile())?.data;
          this.user = data?.user;
      }
      if(data) {
          this.projects = data?.projects;
          this.qualifications = data?.qualifications;
          this.rating = data?.rating;
          this.roles = data?.roles;
          this.businesses = data?.businesses;
          this.selectedBusiness = this.businesses.find(key => {
            return key.businessUserId === this.user.defaultBusinessUserId;
          });
          this.selectedSoftwares = data?.softwares;
          this.selectedSecondaryAreas = data?.secondaryAreas;
      }

      getSoftware().then(result => {
        this.softwares = result.data;
      });

      if (this.isCurrentUser) {
        getAreasByType(AreaType.SECONDARY).then(result => {
          this.secondaryAreas = result.data;
        });
      }

    }
}
</script>
